/* Configuracion - Panel (ya seleccionó un panel y aplica la primera lectura del api)*/

//*react- recursos
    import { useState, useEffect } from "react";
    import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
    import CargandoSpin from "../../../../componentes/CargandoSpin";
    import { SlidingPanel } from "@reactjscomponentrepository/frontend-components/lib/components";

//*clases 
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css'; 

//*archivos (imagenes y elementos necesarios para la rutina)
    import PanelEditarUP from "./Configuracion.Panel.EditarUP"; //usuarios proponentes 
    import PanelEditarUN from "./Configuracion.Panel.EditarUN"; //usuarios para notificaciones

//*api's (servicios y store)
    import configurationsServicio from "../../../../api/recursos/configurations/configurations.servicio"; 
    import configurationsStore    from "../../../../api/recursos/configurations/configurations.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  
//*interfaces
    interface propsPanel {
        tokenStore: any;
        idPanel: any,
        panelStore:any,
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not: any;
    }

//*componente
 export default function Panel(props: propsPanel) {  
    //*api store
        const { guardaGetSummaryProponentUserStore, usuariosProponentesStore, 
                guardaGetSummaryUserNotificationbyEmailStore, usuariosNotificacionesStore,
                catalogoPermisosUsuariosStore, permisosUsuariosStore,
                generaObjErrorConfigurationsStore} =  
            configurationsStore((state:any) =>( { 
                guardaGetSummaryProponentUserStore: state.guardaGetSummaryProponentUserStore,
                usuariosProponentesStore: state.usuariosProponentesStore,
                guardaGetSummaryUserNotificationbyEmailStore: state.guardaGetSummaryUserNotificationbyEmailStore,
                usuariosNotificacionesStore: state.usuariosNotificacionesStore,
                catalogoPermisosUsuariosStore: state.catalogoPermisosUsuariosStore,
                permisosUsuariosStore: state.permisosUsuariosStore,
                generaObjErrorConfigurationsStore: state.generaObjErrorConfigurationsStore
        }));

    //*store's
     
    //*datos

    //*constantes y variables
        let eti= etiquetasSSC.Configuracion;
        
    //*useState
        const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar
        const [swRecargaConfiguracionPanel, setSwRecargaConfiguracionPanel] = useState(false); //usado para remasterizar esta página
        const [cargandoSpin, setCargandoSpin] = useState(false);

        //para usuarios proponentes
        const [upId, setUpId] = useState(null);
        const [upAcronimo, setUpAcronimo] = useState(null);
        const [upProceso, setUpProceso] = useState(null);
        const [upCatPermisos, setUpCatPermisos] = useState(null);
        const [upCatPermisosOrigen, setUpCatPermisosOrigen] = useState(null);
        const [upSwUE, setupSwUE] = useState(false);
        const [upUsuariosEspecificos, setUpUsuariosEspecificos] = useState([]);
        const [upSwUsuariosEspecificos, setUpSwUsuariosEspecificos] = useState(false);
        const [upMisUsuEspecificosOrigen, setUpMisUsuEspecificosOrigen] = useState([]);

        const [misNoAceptadasOrigen, setMisNoAceptadasOrigen] = useState([]);
        const [misAceptadasOrigen, setMisAceptadasOrigen] = useState([]);
        const [misConcluidasOrigen, setMisConcluidasOrigen] = useState([]);
        
        //const [usuariosProponentesFront, setUsuariosProponentesFront] = useState([]);

        //para usuarios para notificaciones
        const [unId, setUnId] = useState(null);
        const [unAcronimo, setUnAcronimo] = useState(null);
        const [unProceso, setUnProceso] = useState(null);
        const [unUsuNoAceptadas, setUnUsuNoAceptadas] = useState([]);
        const [unUsuAceptadas, setUnUsuAceptadas] = useState([]);
        const [unUsuConcluidas, setUnUsuConcluidas] = useState([]);
        //const [usuariosNotificacionesFront, setUsuariosNotificacionesFront] = useState([]);

        const [abreSP, setAbreSP] = useState(false);
       
      
    //*useEffect
        useEffect(()=> { // monto
            console.log('Panel - monto');
            //console.log('idPanel: ', props.idPanel);

            //Alta de usuarios proponentes //lee API:  Configurations/GetSummaryProponentUser
            if (props.idPanel==0) { 
                setCargandoSpin(true);
                configurationsServicio.cargaGetSummaryProponentUser(props.tokenStore) 
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetSummaryProponentUserStore(response.data).then( function(datos:any) { 
                            //console.log('genero datos para usuariosProponentesStore:', datos);
                            //setUsuariosProponentesFront(datos);
                            setSwRecarga(!swRecarga);
                        })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetSummaryProponentUser): ", ex.response.status);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else
                        generaObjErrorConfigurationsStore(ex.response, true, '', '', 'Configuracion-Panel/GetSummaryProponentUser','C')
                    setCargandoSpin(false);
                    recargaPaginaSSC();
                })
            } 
            //Adicionar usuarios para notificaciones vía correo electrónico  //lee API:  Configurations/GetSummaryUserNotificationbyEmail
            if (props.idPanel==1) { 
                setCargandoSpin(true);
                configurationsServicio.cargaGetSummaryUserNotificationbyEmail(props.tokenStore) 
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetSummaryUserNotificationbyEmailStore(response.data).then( function(datos:any) { 
                            //console.log('genero datos para usuariosNotificacionesStore:', datos);
                            //setUsuariosNotificacionesFront(datos);
                            setSwRecarga(!swRecarga);
                        })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetSummaryProponentUser): ", ex.response.status);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else
                        generaObjErrorConfigurationsStore(ex.response, true, '', '', 'Configuracion-Panel/GetSummaryUserNotificationbyEmail','C')
                    setCargandoSpin(false);
                    recargaPaginaSSC();
                })
            }  
        },[]);

        useEffect(()=> { // uso este puente para recargar elementos del front
            console.log('Panel - rederizando............');
            //console.log('idPanel: ', props.idPanel);
            //console.log('usuariosProponentesStore', usuariosProponentesStore);
            //console.log('usuariosProponentesFront', usuariosProponentesFront);
            setSwRecargaConfiguracionPanel(!swRecargaConfiguracionPanel);
        },[swRecarga]);

    //*funciones
        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC

        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

        //const recargaConfiguracion = () => { props.recargaConfiguracion() } //no ocupa actualización

        const recargaConfiguracionPanel = () => {
            //alert('recargaConfiguracionPanel');
            //console.log('recargaConfiguracionPanel....')
            setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
        }

        const botonCierraSlidingPanel = (opcBtnAcepReg:any) => {  setAbreSP(false) }

        const botonEditarUP = (up:any) => { //clic en botón Editar de "Alta de usuarios proponentes"
            //.id, up.acronym, up.name, up.setting.specificuser
            //alert('botonEditarUP...' + id );
            setUpId(up.id);
            setUpAcronimo(up.acronym);
            setUpProceso(up.name);
            setUpCatPermisos(up.catPermisos);
            setUpCatPermisosOrigen(JSON.parse(JSON.stringify(up.catPermisos)));
            setUpSwUsuariosEspecificos(up.swUsuariosEspecificos);
            setUpMisUsuEspecificosOrigen(up.misUsuEspecificosOrigen);
            if (up.misUsuEspecificos.length > 0) { setUpUsuariosEspecificos(up.misUsuEspecificos)  }    
            else {  setUpUsuariosEspecificos([]) }
            setAbreSP(true); // aquí activo ventana SlidingPanel (Ver/Registrar)
        }

        const botonEditarUN = (un:any) => { //clic en botón Editar de "Adicionar usuarios para notificaciones vía correo electrónico"
            //.id, un.acronym, up.name, up.setting.specificuser
            //alert('botonEditarUN...' + id );
            setUnId(un.id);
            setUnAcronimo(un.acronym);
            setUnProceso(un.name);

            setUnUsuNoAceptadas(un.rejectprop);
            setMisNoAceptadasOrigen(un.misNoAceptadas);

            setUnUsuAceptadas(un.okprop);
            setMisAceptadasOrigen(un.misAceptadas);

            setUnUsuConcluidas(un.okanalyse);
            setMisConcluidasOrigen(un.misConcluidas);

            setAbreSP(true); // aquí activo ventana SlidingPanel (Ver/Registrar) 
        }

    //*vista
     return (
      <> 
       {/* paneles */}

       {/* id=0 - Alta de usuarios proponentes */}
        {props.idPanel == 0 &&
          (<>
            <div className='container'>
             <div className="padding-1r">
                <div className="table-responsive">

                    <table className="table table-bordered small background-color-white">
                        <thead id="theadTablaRP">
                            <tr className="background-color-azul7 font-weight-normal  align-top">
                                <th ><span className='font-size-12'> Procesos </span></th>
                                <th ><span className='font-size-12'> Usuarios autorizados </span></th>
                                <th> &nbsp; </th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            { usuariosProponentesStore?.map((up:any, indexUP:any) =>
                              (<>
                                <tr className="colorGris1 padding15Left ">

                                    {/* procesos */}
                                    <td>
                                        {indexUP != 0 && (<span className='color-secundario h5'>{up.acronym}<br/></span>) }
                                        <span className={indexUP==0 ? 'color-secundario h5' : ''}>{up.name}</span>&nbsp;
                                        <span className={indexUP!=0 ? up.clasexEstatusIcono : ''}>{up.state_process.pt_state_description}</span>
                                    </td>

                                    {/* usuarios autorizados: derechos de usuario por programa */}
                                    <td>
                                     {/* usuarios autorizados */}   
                                       { up.catPermisos?.map((catPer:any, indexMiCatPer:any) => (
                                         (<>
                                            { catPer.activo &&
                                              (<>
                                                <span><i className="mdi mdi-check colorBlue1"></i>{catPer.descripcion}</span><br/>
                                              </>)  
                                            }  
                                         </>)
                                       ))} 
                                     {/* usuarios especificos */}
                                       { up.misUsuEspecificos.length > 0 && 
                                         (<>
                                            {up.misUsuEspecificos?.map((usu:any, indexDes:any) => (
                                              (<>
                                                <div className="row padding-left-1r "> 
                                                    <div className="col-md-12">
                                                    <span className="noBR font-size-8">
                                                        <i className="mdi mdi-account-check-outline colorBlue1">&nbsp;</i>{usu.name}</span>
                                                    <br/>
                                                    <span className="noBR font-size-8 padding-left-1r">
                                                        <i className="mdi mdi-email-check-outline colorBlue1">&nbsp;</i>{usu.account}</span>
                                                    </div>
                                                </div>    
                                              </>)  
                                            ))}  
                                         </>)
                                       }
                                    </td>    

                                    {/* botón Editar  */}
                                    <td>
                                        <button type="button" title={indexUP==0 ? "Edita todos los procesos a mi cargo" : "Edita solo el proceso seleccionado"}
                                            className={indexUP==0 ? 'btn rounded-pill noBR min-width-100 background-color-Orange font-size-10' : 'btn rounded-pill noBR min-width-100 background-color-azul8 font-size-10'}
                                            onClick={() => botonEditarUP(up)} >
                                            <i className="mdi mdi-cursor-default-click"></i>&nbsp;Editar
                                        </button>
                                    </td>
                                </tr>
                              </>)
                            )}  
                        </tbody>
                    </table>

                </div>
              </div> 
            </div>
          </>)
        }

       {/* id=1 - Adicionar usuarios para notificaciones vía correo electrónico */}
        {props.idPanel == 1 &&
          (<>
            <div className='container'>
              <div className="padding-1r">
                <div className="table-responsive">
                    <table className="table table-bordered small background-color-white">
                        <thead id="theadTablaRP">
                            <tr className="background-color-azul7 font-weight-normal  align-top">
                                <th rowSpan={2} className='align-middle font-size-12'> Procesos </th>
                                <th colSpan={3} className='text-align-center font-size-12'> Propuestas de cambio </th>
                                <th rowSpan={2}> &nbsp; </th>
                            </tr>
                            <tr className="background-color-azul7 font-weight-normal  align-top">
                                <th className='text-align-center'> No aceptadas </th>
                                <th className='text-align-center'> Aceptadas </th>
                                <th className='text-align-center'> Concluidas </th>
                            </tr>
                        </thead>
                        <tbody>
                            { usuariosNotificacionesStore?.map((un:any, indexUN:any) =>
                              (<>
                                <tr className="colorGris1 padding15Left ">
                                    {/* procesos */}
                                    <td>
                                        {indexUN != 0 && (<span className='color-secundario h5'>{un.acronym}<br/></span>) }
                                        <span className={indexUN==0 ? 'color-secundario h5' : ''}>{un.name}</span> &nbsp;
                                        <span className={indexUN!=0 ? un.clasexEstatusIcono : ''}>{un.state_process.pt_state_description}</span>
                                    </td>

                                    {/* no aceptadas */}
                                    <td>
                                       { un.rejectprop.length > 0 &&
                                          (<>
                                            { un.rejectprop?.map((na:any, indexNA:any) => (
                                                (<>
                                                    <span className="noBR small margin-1r">
                                                        <i className="mdi mdi-email-check-outline colorBlue1">&nbsp;</i>{na.account}
                                                    </span><br />
                                                </>)
                                            ))} 
                                         </>)
                                       } 
                                       
                                    </td>  

                                    {/* aceptadas */}
                                    <td>
                                       { un.okprop.length > 0 &&
                                          (<>
                                            { un.okprop?.map((a:any, indexA:any) => (
                                                (<>
                                                    <span className="noBR small margin-1r">
                                                        <i className="mdi mdi-email-check-outline colorBlue1">&nbsp;</i>{a.account}
                                                    </span><br />
                                                </>)
                                            ))}
                                          </>)
                                       }   
                                    </td>

                                    {/* concluidas */}
                                    <td>
                                        { un.okanalyse.length > 0 &&
                                          (<>
                                            { un.okanalyse?.map((c:any, indexC:any) => (
                                                (<>
                                                    <span className="noBR small margin-1r">
                                                        <i className="mdi mdi-email-check-outline colorBlue1">&nbsp;</i>{c.account}
                                                    </span><br />
                                                </>)
                                            ))} 
                                          </> )
                                        }  
                                    </td>

                                    {/* botón Editar  */}
                                    <td>
                                        <button type="button" title={indexUN==0 ? "Edita todos los procesos a mi cargo" : "Edita solo el proceso seleccionado"}
                                            className={indexUN==0 ? 'btn rounded-pill noBR min-width-100 background-color-Orange font-size-10' : 'btn rounded-pill noBR min-width-100 background-color-azul8 font-size-10'}
                                            onClick={() => botonEditarUN(un)} >
                                            <i className="mdi mdi-cursor-default-click"></i>&nbsp;Editar
                                        </button>
                                    </td>

                                </tr>
                              </>)
                            )}  
                        </tbody>
                    </table>
                </div>
              </div>
            </div>
          </>)
        } 

       {/* ventana izquierda que abre cuando se selecciona un proceso */}  
        <SlidingPanel isOpen={abreSP} type='right' size={60}
            title={props.panelStore[props.idPanel].texto}
            closeClick={()=>botonCierraSlidingPanel("")} >
                {props.idPanel==0 && 
                    (  <PanelEditarUP 
                        tokenStore = {props.tokenStore}
                        idPanel = {props.idPanel}
                        upId = {upId}
                        upAcronimo = {upAcronimo}
                        upProceso = {upProceso}
                        upCatPermisos = {upCatPermisos}
                        upCatPermisosOrigen = {upCatPermisosOrigen}
                        upUsuariosEspecificos = {upUsuariosEspecificos}
                        upMisUsuEspecificosOrigen = {upMisUsuEspecificosOrigen}
                        upSwUsuariosEspecificos = {upSwUsuariosEspecificos}
                        botonCierraSlidingPanel = {botonCierraSlidingPanel}
                        recargaConfiguracionPanel = {recargaConfiguracionPanel}
                        recargaPaginaSSC = {recargaPaginaSSC}
                        recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                    />)
                }
                {props.idPanel==1 && 
                    (  <PanelEditarUN 
                        tokenStore = {props.tokenStore}
                        idPanel = {props.idPanel}
                        unId = {unId}
                        unAcronimo = {unAcronimo}
                        unProceso = {unProceso}
                        unUsuNoAceptadas = {unUsuNoAceptadas}
                        unUsuAceptadas = {unUsuAceptadas}
                        unUsuConcluidas = {unUsuConcluidas}
                        unMisNoAceptadasOrigen= {misNoAceptadasOrigen}
                        unMisAceptadasOrigen= {misAceptadasOrigen}
                        unMisConcluidasOrigen= {misConcluidasOrigen}
                        botonCierraSlidingPanel = {botonCierraSlidingPanel}
                        recargaConfiguracionPanel = {recargaConfiguracionPanel}
                        recargaPaginaSSC = {recargaPaginaSSC}
                        recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                    />)
                }
                 
        </SlidingPanel>


       {/* ventana de carga con spin que se abre mientras lee el api */}
        { cargandoSpin && <CargandoSpin />  }

      </>
     );
 }


  /* switch(responseAPI.status){
                    case 404:  paso.desresul= "El usuario no existe"; break;
                    case 401:  paso.desresul= "No autorizado"; break;
                    case 404:  paso.desresul= "No tiene información"; break;
                    default: paso.desresul= responseAPI.statusText; break;
                  } */

/* className={props.misPropuestas.sent ? 'divCatalogoDisabled' :'divCatalogo'} */